import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-or-edit-payment-processors',
  templateUrl: './add-or-edit-payment-processors.component.html',
  styleUrls: ['./add-or-edit-payment-processors.component.scss']
})
export class AddOrEditPaymentProcessorsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
